const TILE_SIZE = '36px';
const TILE_SIZE_SMALL = '22px';

export const columnLayoutStyles = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

export const scrollableColumnStyles = {
  flex: 1,
  overflowY: 'auto',
};

export const sectionHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  mb: '12px',
};

export const sectionHeaderCountStyles = {
  marginLeft: 'auto',
};

export const linkNameCellStyles = {
  flex: 1,
  minWidth: 0,
};

export const linkNameTypographyStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const linkActionsBoxStyles = {
  display: 'flex',
  gap: '4px',
};

export const groupHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  mb: 1,
};

export const groupCountBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '20px',
  height: '20px',
  borderRadius: '10px',
  px: '6px',
  backgroundColor: ({ palette }) => palette.background.secondary,
  color: ({ palette }) => palette.text.secondary,
};

export const groupWrapperStyles = {
  mb: 2,
};

export const linkCardStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  border: ({ palette }) => `1px solid ${palette.divider}`,
  borderRadius: '10px',
  padding: '10px 12px',
  mb: 1,
  backgroundColor: ({ palette }) => palette.background.paper,
  '&:hover': {
    borderColor: ({ palette }) => palette.grey[400],
    boxShadow: ({ palette }) => palette.shadow?.s,
  },
};

export const emptySlotStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  border: ({ palette }) => `1px dashed ${palette.grey[300]}`,
  borderRadius: '10px',
  padding: '10px 12px',
  mb: 1,
  cursor: 'pointer',
  backgroundColor: ({ palette }) => palette.background.secondary,
  color: ({ palette }) => palette.text.secondary,
  '&:hover': {
    borderColor: ({ palette }) => palette.primary.main,
    backgroundColor: ({ palette }) => `${palette.primary.main}08`,
    color: ({ palette }) => palette.primary.main,
  },
};

export const footerStyles = {
  display: 'flex',
  gap: '8px',
  pt: 2,
  borderTop: ({ palette }) => `1px solid ${palette.divider}`,
  mt: 'auto',
};

export const autocompleteRowStyles = {
  mb: 2,
};

/**
 * Colored entity-type tile on a group header — 22×22 px with per-type bg/fg injected inline.
 */
export const getGroupIconTileStyles = ({ bg, fg }) => ({
  width: TILE_SIZE_SMALL,
  height: TILE_SIZE_SMALL,
  borderRadius: '6px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  backgroundColor: bg,
  color: fg,
});

/**
 * Larger colored entity-type tile on a link card — 36×36 px.
 */
export const getCardIconTileStyles = ({ bg, fg }) => ({
  width: TILE_SIZE,
  height: TILE_SIZE,
  borderRadius: '9px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  backgroundColor: bg,
  color: fg,
});

/**
 * Per-group "+ Add" button shown in the group header row.
 */
export const groupAddButtonStyles = {
  ml: 'auto',
  fontSize: '11px',
  fontWeight: 700,
  color: ({ palette }) => palette.primary.main,
  border: ({ palette }) => `1px solid ${palette.divider}`,
  borderRadius: '7px',
  padding: '4px 8px',
  minWidth: 0,
  '&:hover': {
    backgroundColor: ({ palette }) => `${palette.primary.main}0f`,
    borderColor: ({ palette }) => palette.primary.light,
  },
};

/**
 * Compact icon-only action button on a link card (open / unlink).
 */
export const cardIconButtonStyles = {
  width: '28px',
  height: '28px',
  borderRadius: '7px',
  p: 0,
  color: ({ palette }) => palette.text.secondary,
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
    color: ({ palette }) => palette.text.primary,
  },
};

export const cardOpenIconButtonStyles = {
  ...cardIconButtonStyles,
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.hoverDefault,
    color: ({ palette }) => palette.primary.main,
  },
};

export const aiSuggestBannerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  border: '1px solid #ddd2f5',
  background: 'linear-gradient(180deg,#f6f1ff,#ffffff)',
  borderRadius: '10px',
  padding: '10px 12px',
  mb: 1,
};

export const aiSuggestTileStyles = {
  width: '34px',
  height: '34px',
  borderRadius: '8px',
  backgroundColor: '#eae4ff',
  color: '#5428d0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
};

export const aiSuggestMidStyles = {
  flex: 1,
  minWidth: 0,
};

export const aiSuggestLabelStyles = {
  color: '#5428d0',
  textTransform: 'uppercase',
  letterSpacing: '0.4px',
  display: 'block',
  mb: '2px',
};

export const aiSuggestLinkButtonStyles = {
  fontSize: '12px',
  fontWeight: 700,
  color: '#ffffff',
  backgroundColor: '#5428d0',
  borderRadius: '6px',
  px: '10px',
  py: '6px',
  border: 'none',
  cursor: 'pointer',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: '#3d1fa3',
  },
};

export const aiSuggestDismissButtonStyles = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '6px',
  color: ({ palette }) => palette.text.secondary,
  flexShrink: 0,
  '&:hover': {
    color: ({ palette }) => palette.text.primary,
  },
};
